@if(isMobile()){

<!-- @if (shouldDisplayPendingChangesAlert()) {
<div class="alert alert-warning border-0 d-flex align-items-center animated fadeIn submitReminder gap-2 m-0"
  role="alert">
  <div class="h7-regular">
    Your added product(s) won’t be saved until you visit your cart and click <b><i>"Submit Order".</i></b>
  </div>
  <i class="fa-solid fa-arrow-down pe-2 fa-bounce"></i>
</div>
} -->

<div class="mobile-nav-bottom">


  <button type="button" class="btn-action" routerLinkActive="active-link" routerLink="/shop">
    <span class="btn-action__icon material-symbols-outlined">nutrition</span>
    <span class="btn-action__text">Products</span>
  </button>
  <button type="button" class="btn-action" routerLinkActive="active-link" routerLink="/favorites">
    <span class="btn-action__icon material-symbols-outlined">favorite</span>
    <span class="btn-action__text">Favorites</span>
  </button>
  <button type="button" class="btn-action" (click)="openModalBundles()">
    <span class="btn-action__icon material-symbols-outlined">orders</span>
    <span class="btn-action__text">Farm box</span>
  </button>
  <button type="button" class="btn-action" routerLinkActive="active-link" routerLink="/order">
    <span class="btn-action__icon material-symbols-outlined">shopping_cart</span>
    <span class="btn-action__text">Cart</span>
    @if (orderProductsQuantity()) {
    <span class="quanity-badge">
      {{ orderProductsQuantity() }}
    </span>
    }
  </button>
  <!-- <button type="button" class="btn-action" routerLinkActive="active-link" routerLink="/order">
    <span class="btn-action__icon material-symbols-outlined">credit_card</span>
    <span class="btn-action__text">Checkout</span>
    @if (orderProductsQuantity()) {
    <span class="quanity-badge">
      {{ orderProductsQuantity() }}
    </span>
    }
  </button> -->
</div>
}